// extracted by mini-css-extract-plugin
module.exports = {"collections_container":"Collections_collections_container__2JXcI"};